// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slick-carousel/slick/slick-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0px;
  font-family: "Urbanist", sans-serif;
  background-color: none;
  overflow: auto;
}

body::-webkit-scrollbar {
  display: none;
}
p {
  margin: 0px;
}
ul,
ol {
  padding: 0px;
  list-style: none;
  margin: 0px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
}
a {
  text-decoration: none;
  display: inline-block;
}
span,
strong {
  display: inline-block;
}

.rdp {
  --rdp-cell-size: 36px;
  --rdp-accent-color: #0077ff;
  --rdp-background-color: #e7f2ff;
  margin: 0;
}

.rdp-day {
  border-radius: 6px;
  font-size: 13px;
}

.rdp-day_selected {
  background-color: var(--rdp-accent-color);
  color: white;
}

.rdp-day_selected:hover {
  background-color: var(--rdp-accent-color);
}

.rdp-day_today:not(.rdp-day_selected) {
  font-weight: bold;
  color: var(--rdp-accent-color);
}

.rdp-day_disabled {
  opacity: 0.25;
}

.rdp-caption {
  margin-bottom: 8px;
}

.rdp-caption_label {
  font-size: 14px;
  font-weight: 500;
}

.rdp-nav_button {
  width: 24px;
  height: 24px;
  border-radius: 6px;
}

.rdp-nav_button:hover {
  background-color: #f5f5f5;
}

.custom-datepicker-input {
  width: 130%;
  padding: 5px 10px;
  border: none;
  outline: none;
  font-size: 14px;
  background: transparent;
  cursor: pointer;
  color: #333;
}

.custom-datepicker-input:disabled {
  cursor: not-allowed;
  color: #999;
}

.custom-calendar {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.custom-calendar .react-datepicker__header {
  background-color: #ff3135;
  color: #fff;
  border-bottom: none;
  padding: 12px 20px;
}

.custom-calendar .react-datepicker__day--selected,
.custom-calendar .react-datepicker__day--keyboard-selected {
  background-color: #ff3135 !important;
  color: white !important;
  border-radius: 50%;
}

.custom-calendar .react-datepicker__day--today {
  border-radius: 50%;
  background-color: transparent;
}

.custom-calendar .react-datepicker__time-container {
  border-left: 1px solid #ff7578;
}

.custom-calendar .react-datepicker__time-list-item--selected {
  background-color: #ff3135 !important;
}

.datepicker-clear-button {
  padding: 4px 8px;
  border: none;
  background: #f0f0f0;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
}

.datepicker-clear-button:hover {
  background: #e0e0e0;
}

.custom-popper {
  z-index: 1000;
}

.react-datepicker__current-month {
  color: white;
}
.react-datepicker__day-name {
  color: white;
}
.react-datepicker-time__header {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/global.css"],"names":[],"mappings":"AAGA;EACE,WAAW;EACX,mCAAmC;EACnC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap\");\n@import \"~slick-carousel/slick/slick.css\";\n@import \"~slick-carousel/slick/slick-theme.css\";\nbody {\n  margin: 0px;\n  font-family: \"Urbanist\", sans-serif;\n  background-color: none;\n  overflow: auto;\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\np {\n  margin: 0px;\n}\nul,\nol {\n  padding: 0px;\n  list-style: none;\n  margin: 0px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0px;\n}\na {\n  text-decoration: none;\n  display: inline-block;\n}\nspan,\nstrong {\n  display: inline-block;\n}\n\n.rdp {\n  --rdp-cell-size: 36px;\n  --rdp-accent-color: #0077ff;\n  --rdp-background-color: #e7f2ff;\n  margin: 0;\n}\n\n.rdp-day {\n  border-radius: 6px;\n  font-size: 13px;\n}\n\n.rdp-day_selected {\n  background-color: var(--rdp-accent-color);\n  color: white;\n}\n\n.rdp-day_selected:hover {\n  background-color: var(--rdp-accent-color);\n}\n\n.rdp-day_today:not(.rdp-day_selected) {\n  font-weight: bold;\n  color: var(--rdp-accent-color);\n}\n\n.rdp-day_disabled {\n  opacity: 0.25;\n}\n\n.rdp-caption {\n  margin-bottom: 8px;\n}\n\n.rdp-caption_label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.rdp-nav_button {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n}\n\n.rdp-nav_button:hover {\n  background-color: #f5f5f5;\n}\n\n.custom-datepicker-input {\n  width: 130%;\n  padding: 5px 10px;\n  border: none;\n  outline: none;\n  font-size: 14px;\n  background: transparent;\n  cursor: pointer;\n  color: #333;\n}\n\n.custom-datepicker-input:disabled {\n  cursor: not-allowed;\n  color: #999;\n}\n\n.custom-calendar {\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.custom-calendar .react-datepicker__header {\n  background-color: #ff3135;\n  color: #fff;\n  border-bottom: none;\n  padding: 12px 20px;\n}\n\n.custom-calendar .react-datepicker__day--selected,\n.custom-calendar .react-datepicker__day--keyboard-selected {\n  background-color: #ff3135 !important;\n  color: white !important;\n  border-radius: 50%;\n}\n\n.custom-calendar .react-datepicker__day--today {\n  border-radius: 50%;\n  background-color: transparent;\n}\n\n.custom-calendar .react-datepicker__time-container {\n  border-left: 1px solid #ff7578;\n}\n\n.custom-calendar .react-datepicker__time-list-item--selected {\n  background-color: #ff3135 !important;\n}\n\n.datepicker-clear-button {\n  padding: 4px 8px;\n  border: none;\n  background: #f0f0f0;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-left: 8px;\n}\n\n.datepicker-clear-button:hover {\n  background: #e0e0e0;\n}\n\n.custom-popper {\n  z-index: 1000;\n}\n\n.react-datepicker__current-month {\n  color: white;\n}\n.react-datepicker__day-name {\n  color: white;\n}\n.react-datepicker-time__header {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
